// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileMain-module__Container__I8kn6 {
    height: 100vh;
    /*  The background of the whole app: */
    background-color: var(--ds-color-grey-indigo-100);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `MobileMain-module__Container__I8kn6`
};
export default ___CSS_LOADER_EXPORT___;
